/**
 * Фирменные цвета сети Zerde (из лепестков цветка и логотипа)
 */
export const ZERDE_COLORS = {
  primary: '#1570ef', // Фирменный синий бренд Zerde
  emerald: '#56bf84', // Мятно-зеленый верхний лепесток
  amber: '#f7b744',   // Теплый золотисто-желтый лепесток
  orange: '#f3883a',  // Солнечно-оранжевый лепесток
  ruby: '#d63a4a',    // Рубиново-красный лепесток
  darkSurface: 'rgba(255, 255, 255, 0.04)',
  borderLight: 'rgba(255, 255, 255, 0.08)',
  textMuted: '#a1a1aa'
} as const;

/**
 * Две колонки (боковое меню профиля 280px + разделы) - по ширине страницы профиля, а не окна:
 * рядом с боковым меню панели при окне 900-1200px разделам оставалось ~230px.
 * Контейнер `profile` задает UserProfilePage.
 */
export const PROFILE_WIDE = '@container profile (min-width: 880px)';
